var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInductionBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7995_8206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6.07281H11.75V3.82281C11.75 2.99781 11.075 2.32281 10.25 2.32281H8.75C7.925 2.32281 7.25 2.99781 7.25 3.82281V6.07281H3.5C2.675 6.07281 2 6.74782 2 7.57281V15.8228C2 16.6478 2.675 17.3228 3.5 17.3228H15.5C16.325 17.3228 17 16.6478 17 15.8228V7.57281C17 6.74782 16.325 6.07281 15.5 6.07281ZM7.25 9.82281C7.8725 9.82281 8.375 10.3253 8.375 10.9478C8.375 11.5703 7.8725 12.0728 7.25 12.0728C6.6275 12.0728 6.125 11.5703 6.125 10.9478C6.125 10.3253 6.6275 9.82281 7.25 9.82281ZM9.5 14.3228H5V13.7603C5 13.0103 6.5 12.6353 7.25 12.6353C8 12.6353 9.5 13.0103 9.5 13.7603V14.3228ZM10.25 7.57281H8.75V3.82281H10.25V7.57281ZM14 13.1978H11V12.0728H14V13.1978ZM14 10.9478H11V9.82281H14V10.9478Z",
    fill: "#6FCF97"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7995_8206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.822815)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInductionBadge);
export default __webpack_public_path__ + "static/media/induction_badge.b213b4ee83802dcc5ea1ab85c31ecceb.svg";
export { ForwardRef as ReactComponent };